module.exports = __webpack_public_path__ + "img/sofa_marrom.d4f95b3e.png";